export const ITipRepositoryType = Symbol('ITipRepository');
